async function getClientIP() {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('Error fetching IP:', error);
    return null;
  }
}
// Modified motor function with IP
async function startMotor1() {
  try {
    // Get the client IP first
    const clientIP = await getClientIP();
    console.log('Client IP:', clientIP);

    // Create the request
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        console.log(this.responseText); 
      }
    };

    // Option 1: Send IP as query parameter
    const url = clientIP 
      ? `https://motor.altaran.us/motorOn?clientIP=${clientIP}`
      : "https://motor.altaran.us/motorOn";

    xhttp.open("GET", url, true);
    xhttp.send();

  } catch (error) {
    console.error('Error starting motor:', error);

    // Fallback: send request without IP if IP fetch fails
    xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        console.log(this.responseText); 
      }
    };
    xhttp.open("GET", "https://motor.altaran.us/motorOn", true);
    xhttp.send();
  }
}
export default startMotor1
